// extracted by mini-css-extract-plugin
export default {"container":"ProductTypesContainer_container__eO1wJ","header":"ProductTypesContainer_header__OeRFp"};